

define(['jquery', 'squid/index', 'text!./template.html', './lib/pxp', './lib/cart_pxp', './lib/ui', 'components/xo-models/src/checkout/index', 'xo-ui-components/src/accessibility/directive', './cartWrapper/directive', './itemDetails/directive'], function ($, squid, template) {

    squid.module('xo-cart.directive', ['squid', 'xomodel.checkout', 'xo-cart.pxp', 'xo-cart.ui', 'xo-cart.cart-wrapper.directive', 'xo-cart.item-details.directive', 'xo-accessibility.directive']).directive('xoCart', function () {

        return {
            template: template,
            restrict: 'E',
            scope: {
                showCartTotal: '=',
                renderCartContainer: '=',
                token: '='
            },
            controller: function controller( // eslint-disable-line max-params
            $scope, $populate, $rootScope, $util, $state, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $pxpCartAmt, $pxpCartDesc) {

                $util.assert($scope.token, 'Expected token');

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then($pxpCartDesc).then(function loadCartData(canShowCart) {

                    var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                    var cartDesc = $scope.checkoutCart.get('purchase.description');
                    $scope.note = $scope.checkoutCart.get('note');

                    if (!canShowCart) {
                        cartDesc = '';
                    } else
                        // resolve string in descriptions array since the only element may be `null`
                        // TODO: fix backend to return a string, to avoid this conditional
                        if (cartDesc && angular.isString(cartDesc[0])) {
                            cartDesc = cartDesc[0];
                        } else {
                            cartDesc = '';
                        }

                    $scope.desc = cartDesc;
                    $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
                    $scope.showArrow = !$scope.checkoutAppData.flags.hide_cart_details && (cartDesc || $scope.hasItems || $scope.note);

                    // add details to render to the checkoutCart items
                    $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
                        item.details = {};

                        if (item.quantity > 1) {
                            item.details.price = item.price.amount;
                            item.details.quantity = item.quantity;
                        }

                        if (item.description) {
                            if (!item.name) {
                                item.name = item.description;
                            } else {
                                item.details.description = item.description;
                            }
                        }

                        // move options to detail section
                        if (item.item_option_selections) {
                            item.details.hasSelections = true;
                            item.details.item_option_selections = item.item_option_selections;
                        }

                        if (item.sku) {
                            item.details.sku = item.sku;
                        }

                        item.hasDetails = Object.keys(item.details).length > 0;
                        item.details.hasMore = item.hasDetails || item.details.hasSelections;
                    });

                    // Mapping of field name as recieved by API to corresponding property key
                    $scope.amountHeaders = {
                        'total': 'header.total',
                        'subtotal': 'header.itemTotal',
                        'tax': 'header.tax',
                        'shipping': 'header.shipping',
                        'insurance': 'header.insurance',
                        'handling_fee': 'header.handling',
                        'shipping_discount': 'header.shippingDiscount',
                        'description': 'header.description',
                        'discount': 'header.discount'
                    };

                    // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
                    // are not available and purchase amount is not zero.
                    var userAction = $scope.userAction = $util.param('useraction');
                    var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;

                    return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                        $scope.showAmt = showAmount;
                    });
                }).then(function handleCartOpenClose() {
                    // the cart is only automatically open under the following criteria:
                    // 1. the cart has a 'note to buyer' ($scope.note is defined)
                    // 2. the cart was not previously automatically opened before
                    // 3. the state has transitioned to checkout.review or checkout.guest
                    function decideShowCart(currentState) {
                        if ($scope.note && !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState)) {
                            $scope.openedAlready = true; // may have been undefined before
                            return true;
                        }

                        return false;
                    }

                    $scope.showCartItem = function (breakdown) {
                        return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
                    };

                    $scope.showCart = decideShowCart($state.current.name);

                    // TODO: Must we really couple this so tightly with the state transition names?
                    var openCartListener = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
                        $scope.showCart = decideShowCart(toState.name);
                    });
                    $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy

                    $scope.toggleCart = function ($event) {
                        $scope.showCart = !$scope.showCart;
                        $event.preventDefault();
                    };

                    $scope.closeCart = function ($event) {
                        $scope.showCart = false;
                        // for accessible autofocus on cart toggle link button
                        $scope.$broadcast('cart-closed');
                        if ($event) {
                            $event.preventDefault();
                        }
                    };

                    $scope.$on('clickBody', function ($event, target) {
                        if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
                            $scope.closeCart($event);
                            $scope.$apply();
                        }
                    });

                    // this listener / broadcast allows accessibility components to scan and focus inside the cart
                    // when the cart is displayed
                    $scope.$watch('showCart', function (showCart) {
                        if (showCart) {
                            $scope.$broadcast('cart-updated');
                        }
                    });
                }).then(function handleEllipsisIssues() {
                    // NOTE: the scattered broadcasts of "cart-updated" events are mostly
                    // to allow the accessibility directives modal-box and focus-when to
                    // know when to recalculate keyboard behavior / focus
                    $scope.toolongTracker = {};

                    // this function is invoked by the onEllipsis directive that tracks
                    // if the item name won't fit within the restricted space.
                    $scope.toolong = function (idx) {
                        $scope.toolongTracker[idx] = true;
                        $scope.$broadcast('cart-updated');
                    };

                    $scope.showMore = function (idx, type) {
                        // there are 2 types of more, "floating" when the name is too long
                        // and "inline" when the name can fit, but there are additional details.
                        //
                        // Show a more if the item
                        // 1. has an expanded state
                        // 2. is not already expanded
                        // 3. if it is appropriate to show that type.
                        var itemIsTooLong = $scope.toolongTracker[idx];
                        var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';

                        return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
                    };

                    $scope.expandedIndex = -1; // initially, none of the line items are expanded
                    $scope.isExpanded = function isExpanded(idx) {
                        return idx === $scope.expandedIndex;
                    };
                    $scope.hasExpandedState = function hasExpandedState(idx) {
                        // A line item is exandable if
                        // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
                        // 2. there are details (attached to purchase.items in the cart)
                        // 3. there is item number (sku) in the item
                        var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
                        var nameTooLong = $scope.toolongTracker[idx];
                        return nameTooLong || item.hasDetails || item.sku;
                    };
                    $scope.expand = function expand(idx) {
                        $scope.expandedIndex = idx;
                        $scope.$broadcast('cart-updated');
                    };
                    $scope.collapse = function collapse() {
                        $scope.expandedIndex = -1;
                        $scope.$broadcast('cart-updated');
                    };

                    $scope.$emit('dataLoaded');
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-page-components/src/cart/directive.js
 ** module id = 501
 ** module chunks = 1
 **/